import { ObstetricalResourcesAnxietyScreening } from "./ObstetricalResourcesAnxietyScreening";
import { ObstetricalResourcesDepressionScreening } from "./ObstetricalResourcesDepressionScreening";
import { ObstetricalResourcesPostnatalDepressionScale } from "./ObstetricalResourcesPostnatalDepressionScale";
import { ObstetricalResourcesTaceScreening } from "./ObstetricalResourcesTaceScreening";

class ObstetricalFileFormResources {
    public AnxietyScreening: ObstetricalResourcesAnxietyScreening;
    public DepressionScreening: ObstetricalResourcesDepressionScreening;
    public TaceScreening: ObstetricalResourcesTaceScreening;
    public PostnatalDepressionScale: ObstetricalResourcesPostnatalDepressionScale;

    constructor(fields?: Partial<ObstetricalFileFormResources>) {
        this.AnxietyScreening = new ObstetricalResourcesAnxietyScreening(fields?.AnxietyScreening);
        this.DepressionScreening = new ObstetricalResourcesDepressionScreening(fields?.DepressionScreening);
        this.TaceScreening = new ObstetricalResourcesTaceScreening(fields?.TaceScreening);
        this.PostnatalDepressionScale = new ObstetricalResourcesPostnatalDepressionScale(fields?.PostnatalDepressionScale);
    }
}

export { ObstetricalFileFormResources };
